/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPMIMETYPE = {
    ApplicationOrPdf: 'application/pdf',
    ImageOrBmp: 'BMP',
    ApplicationOrMsword: 'DOC',
    ApplicationOrMswordOrDocx: 'DOCX',
    MessageOrRfc822: 'EML',
    ImageOrGif: 'GIF',
    MageOrJpeg: 'JPEG',
    ImageOrJpeg: 'JPG',
    ImageOrPng: 'PNG',
    ApplicationOrRtf: 'RTF',
    ImageOrTif: 'TIF',
    ImageOrTiff: 'TIFF',
    TextOrPlain: 'TXT',
    ApplicationOrVndmsExcel: 'XLS',
    ApplicationOrVndmsExcelOrXlsx: 'XLSX'
} as const;
export type IAPMIMETYPE = typeof IAPMIMETYPE[keyof typeof IAPMIMETYPE];


export function IAPMIMETYPEFromJSON(json: any): IAPMIMETYPE {
    return IAPMIMETYPEFromJSONTyped(json, false);
}

export function IAPMIMETYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPMIMETYPE {
    return json as IAPMIMETYPE;
}

export function IAPMIMETYPEToJSON(value?: IAPMIMETYPE | null): any {
    return value as any;
}

